import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-verkiezingen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVerkiezingen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M14.64 15.67 29.05 1.29c.39-.39 1.02-.39 1.42 0l1.42 1.41-15.12 15.08-2.12-2.12ZM33.3 4.12 18.18 19.2l2.12 2.12L34.71 6.94a.996.996 0 0 0 0-1.41l-1.42-1.41ZM12.29 21.8l1.87 1.87 4.6-1.06-5.41-5.4zm3.93 3.3-1.22.41-.54.14c-.05.01-.1.03-.15.04l-3.68.85c-.07.02-.15.03-.22.03-.26 0-.52-.1-.71-.29-.24-.24-.34-.6-.27-.93l.44-1.92c-.19-.27-.82-1.34-.82-1.34-.5-.82-1.58-1.09-2.41-.58-.83.5-1.09 1.58-.59 2.4l2.83 4.64a1.756 1.756 0 0 0 1.95.78c.75-.2 1.28-.87 1.3-1.65v-.26l2.68.88c.92.3 1.91-.2 2.21-1.11.27-.81-.09-1.67-.81-2.07Zm6.81-2.12c0 5.51-4.48 9.99-10.01 9.99S3 28.5 3 22.98s4.48-9.99 10.01-9.99c.48 0 .95.05 1.41.11l2.1-2.1L2 11.02c-.55 0-1 .45-1 1v21.97c0 .55.45 1 1 1h22.02c.55 0 1-.45 1-1V19.46l-2.11 2.11c.06.46.11.93.11 1.4Z"/>
</svg>

    );
  }
}
